

<app-ip-table
  [optionalTitle]="'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.PAYMENTS_DONE'"
  [tableOption]="tableOptions"
  [propertyOrder]="propertyOrder"
  (action)="onAction($event)"
  [pageItems]="10"
  [filter]="false"
  service="payments-done"
></app-ip-table>
